import * as React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { forgotPassword } from '../actions/auth';
import { Button, Card, notification, Space } from 'antd';
import { Form, Input, Image } from 'antd';

interface Props {
  isAuthenticated: boolean;
  dispatch: any;
}

interface State {
  email: string;
  password: string;
}

class ForgotPassword extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
    };
  }
  componentDidMount() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    this.setState({ email: params.code });
  }

  openNotificationWithIcon = (type, msg, disc) => {
    notification[type]({
      message: msg,
      description: disc,
    });
  };

  getIPAddress = async () => {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  }

  getLocation = (): Promise<{ latitude: number; longitude: number }> => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            });
          },
          (error) => reject(error)
        );
      } else {
        reject(new Error('Geolocation is not supported by this browser.'));
      }
    });
  }

  // Function to get Browser Details
  getBrowserDetails = () => {
    const userAgent = navigator.userAgent;
    return {
      platform: /Mobi|Android|iPhone/i.test(userAgent) ? 'mobile' : 'web',
      userAgent,
    };
  }

  render() {
    if (!this.props.isAuthenticated) {
      return (
        <>
          <Helmet>
            <title>Welcome</title>
          </Helmet>
          <Card style={{ width: 300, margin: 'auto', marginTop: '10%' }} className="max-h-[250px]">
            <Image src={require('./../assets/logo/7851308.png')} preview={false} style={{ width: '100%', height: '60px', marginBottom: 10 }} />
            <Form
              onFinish={async (values) => {
                if (!this.state.email) {
                  const msg = 'Login Fail';
                  const disc = 'Something went wrong!';
                  this.openNotificationWithIcon('error', msg, disc);
                  return;
                }
                const ipAddress = await this.getIPAddress();
                const location = await this.getLocation();
                const browserDetails = this.getBrowserDetails();
                const response = await this.props.dispatch(
                  forgotPassword({
                    email: this.state.email,
                    password: values.newPassword,
                    ipAddress,
                    latitude: location.latitude,
                    longitude: location.longitude,
                    platform: browserDetails.platform,
                    userAgent: browserDetails.userAgent,
                  })
                );
                if (response.code === 200) {
                  const msg = 'Success';
                  const disc = 'Login Success';
                  this.openNotificationWithIcon('success', msg, disc);
                  window.location.replace('/');
                } else {
                  const msg = 'Login Fail';
                  const disc = 'Something went wrong!';
                  this.openNotificationWithIcon('error', msg, disc);
                }
              }}
            >
              <Space direction='vertical' style={{ width: '100%' }}>
                <Form.Item
                  name="newPassword"
                  rules={[{ required: true, message: 'This field is required' }]}
                >
                  <Input.Password placeholder="New Password" />
                </Form.Item>
                <Form.Item
                  name="confirmPassword"
                  dependencies={['newPassword']}
                  rules={[
                    { required: true, message: 'This field is required' },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('newPassword') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error('Passwords must match with Confirm password')
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password placeholder="Confirm Password" />
                </Form.Item>
                <Form.Item style={{ textAlign: 'center' }}>
                  <Button type="primary" htmlType="submit">
                    Change Password
                  </Button>
                </Form.Item>
              </Space>
            </Form>
          </Card>
        </>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(ForgotPassword);
